const boardOptions = [
  { label: 'CISCE', value: 'CISCE' },
  { label: 'CAIE', value: 'CAIE' },
  { label: 'CBSE', value: 'CBSE' },
  { label: 'PUC', value: 'PUC' },
  { label: 'TNBSE', value: 'TNBSE' }
];

export { boardOptions };
